import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const Loader = () => (
  <div className='full-width-loader-container'>
    <CircularProgress />
  </div>
)

export default Loader
